import { useCallback, useContext } from 'react';
import { store } from 'components/Store';
import PeopleAsyncSelect from './PeopleAsyncSelect';

const MembersSelect = ({
  value,
  onChange,
  placeholder = 'Search members...',
  disabled = false,
  menuIsOpen,
  onMenuOpen,
  onMenuClose,
  cornerAction,
}) => {
  const { state } = useContext(store);

  const loadOptions = useCallback(
    (inputValue) => {
      const members = state.team?.allMembers ?? [];
      const term = inputValue.toLowerCase();
      const filtered = term
        ? members.filter((m) => (m.fullName ?? m.emailAddress).toLowerCase().includes(term))
        : members;
      return Promise.resolve([
        {
          label: 'contacts',
          options: filtered.map((m) => ({ value: m.id, id: m.id, label: m.fullName ?? m.emailAddress })),
        },
      ]);
    },
    [state.team?.allMembers]
  );

  return (
    <PeopleAsyncSelect
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      loadOptions={loadOptions}
      menuIsOpen={menuIsOpen}
      onMenuOpen={onMenuOpen}
      onMenuClose={onMenuClose}
      cornerAction={cornerAction}
    />
  );
};

export default MembersSelect;
